import { Breadcrumb, Space, Typography } from 'antd';
import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

const { Title } = Typography;

interface Crumb {
  title: ReactNode;
  to?: string;
}

interface PageHeaderProps {
  title: ReactNode;
  crumbs?: Crumb[];
  extra?: ReactNode;
}

export function PageHeader({ title, crumbs, extra }: PageHeaderProps): JSX.Element {
  return (
    <div style={{ marginBottom: 24 }}>
      {crumbs && crumbs.length > 0 && (
        <Breadcrumb
          style={{ marginBottom: 8 }}
          items={crumbs.map((c) => ({
            title: c.to ? <Link to={c.to}>{c.title}</Link> : c.title,
          }))}
        />
      )}
      <Space style={{ width: '100%', justifyContent: 'space-between' }}>
        <Title level={3} style={{ margin: 0 }}>
          {title}
        </Title>
        {extra}
      </Space>
    </div>
  );
}
